import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/tenant/view/tenant.view.query.gql"
import type {
  TenantViewQuery,
  TenantViewQueryVariables,
} from "@/v2-backoffice-client/tenant/view/__types__/tenant.view.query"

type Options = QueryHookOptions<TenantViewQuery, TenantViewQueryVariables>

export function useTenantViewQuery(options?: Options) {
  return useQuery<TenantViewQuery, TenantViewQueryVariables>(query, options)
}
